import styled from "styled-components";
  
export const HeaderText = styled.span<{color: string}>`
  font-family: NowBlack;
  color: ${(props) => props.color};
  text-transform: uppercase;
  font-size: 18px;
`;